export default __webpack_public_path__ + "b053aa810cb8f00bf211428ebbd72f58.png";